export const scrollToElement = elementId => {
  const inputElement = document.getElementById(elementId);

  if (inputElement) {
    const elementTopPosition = inputElement.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: elementTopPosition, behavior: 'smooth' });
  }
};
